import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Badge from 'react-bootstrap/Badge';
import Nav from 'react-bootstrap/Nav';
import { FaEnvelope } from 'react-icons/fa';
import styled from 'styled-components';

import { miscActions } from '../../actions';
import useDispatch from '../../hooks/useDispatch';
import { usePreferences } from '../../hooks/usePreferences';
import useSelector from '../../hooks/useSelector';
import NoticeModal from './NoticeModal';

const Styles = styled.span`
  position: relative;
  .number-of-unread {
    position: absolute;
    right: -0.5rem;
    font-size: 0.5rem;
  }
`;

const NoticeNavItem: React.FC = () => {
  const dispatch = useDispatch();
  const getPosts = useCallback(() => {
    const fetchPosts = () => dispatch(miscActions.listPosts());
    // refresh the posts every 60 secs
    window.setInterval(fetchPosts, 60_000);
    fetchPosts();
  }, [dispatch]);

  const { unread, clientReadPostIds } = useSelector(
    state => state.misc.listPosts
  );
  const { popUpNoticeModal } = usePreferences();

  const [showModal, setShowModal] = useState(false);
  const [disableBackdropClick, setDisableBackdropClick] = useState(false);
  const popModal = useCallback(() => setShowModal(true), []);
  const hideModal = useCallback(() => {
    setShowModal(false);
    setDisableBackdropClick(false);
  }, []);

  useEffect(getPosts, [getPosts]);

  useEffect(() => {
    if (unread) {
      // determine whether there are auto popup posts
      const unreadPopUpPost = unread.filter(
        post => post.popup && moment().diff(post.created_at, 'day') < 1
      );
      if (popUpNoticeModal && unreadPopUpPost.length > 0) {
        setShowModal(true);
        setDisableBackdropClick(true);
      }
    }
  }, [unread, popUpNoticeModal]);

  const readDotNumber = useMemo(() => {
    // unread object might be outdated because when user read a post,
    // unread object might not be updated in time. We rely on clientReadPostIds to filter out those id
    if (unread?.length > 0) {
      if (!clientReadPostIds) {
        return unread.length;
      }
      return unread.filter(post => !clientReadPostIds.includes(post.id)).length;
    }
    return 0;
  }, [unread, clientReadPostIds]);

  return (
    <>
      <Nav.Link
        key="notice"
        onClick={popModal}
        className="notice-nav-item"
        style={{ paddingTop: '0.375rem' }}
      >
        <Styles>
          <FaEnvelope />
          {readDotNumber > 0 && (
            <Badge className="number-of-unread" pill bg="danger">
              {readDotNumber}
            </Badge>
          )}
        </Styles>
      </Nav.Link>
      <NoticeModal
        show={showModal}
        onHide={hideModal}
        disableBackdropClick={disableBackdropClick}
      />
    </>
  );
};

export default NoticeNavItem;
